const listeners = new Map();

const observer = new IntersectionObserver((entries) => {
  const changes = [];
  for (let entry of entries) {
    const visible = entry.isIntersecting;
    const target = entry.target;
    const wasVisible = target.dataset.visible === "true";
    target.dataset.visible = visible ? "true" : "false";
    if (visible !== wasVisible) {
      changes.push([target, visible]);
    }
  }
  for (let [target, visible] of changes) {
    if (listeners.has(target)) {
      const fn = listeners.get(target);
      fn(visible, target);
    }
  }
});

export function withIntersection(container, opts = {}) {
  const { onChange = () => {} } = opts;
  listeners.set(container, onChange);
  observer.observe(container);
  return {
    destroy() {
      console.log("destroying", container);
      listeners.delete(container);
      observer.unobserve(container);
    },
  };
}
